// extracted by mini-css-extract-plugin
module.exports = {"about":"index_about__CTfB-","about__tab":"index_about__tab__34OgK","about__tab__item":"index_about__tab__item__1-0Zi","about__tab__active":"index_about__tab__active__1y4xE"};